module.exports = __webpack_public_path__ + "img/zhaoming.dae174ea.svg";